import { Component, computed, inject, OnInit, signal, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DashboardDialogFramePart, DialogAction, DialogContext } from '@eforall/dashboard';
import { TabStripModule } from '@progress/kendo-angular-layout';
import { NotesEditorPart } from "../../notes-editor-dialog/notes-editor/notes-editor.part";
import { AccVentureDialogDataService } from './acc-venture-dialog-data.service';
import { AccVentureDetailsPart } from './details/details.part';
import { AccVentureEntrepreneursPart } from './entrepreneurs/entrepreneurs.part';

@Component({
	selector: 'acc-venture-dialog',
	standalone: true,
	imports: [
		DashboardDialogFramePart,
		TabStripModule,
		AccVentureDetailsPart,
		AccVentureEntrepreneursPart,
		NotesEditorPart
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './acc-venture.dialog.html'
})

export class AccVentureDialog implements OnInit {

	public dialogRef = inject(MatDialogRef<AccVentureDialog>);
	public dialogContext: DialogContext<{ accVentureId: number }> = inject(MAT_DIALOG_DATA);
	public readonly dialogDataService = inject(AccVentureDialogDataService);


	async ngOnInit() {
		const data = this.dialogContext.data;
		if (data) {
			await this.dialogDataService.loadData(data.accVentureId);
		}
	}

	public readonly headerName = computed(() => {
		const data = this.dialogDataService.dialogData();
		if (!data) return 'Venture';
		return `Venture: ${data.ventureName}`
	});

	public actions: DialogAction[] = [
		{
			id: 'close',
			cssClass: signal(undefined),
			enabled: signal(true),
			visible: signal(true),
			text: signal('Close'),
			linkType: "no-action",
			willCloseDialog: true,
		}
	];

}